import { render } from "./CrmPointsCard.vue?vue&type=template&id=1f2c4ab4&scoped=true"
import script from "./CrmPointsCard.vue?vue&type=script&lang=js"
export * from "./CrmPointsCard.vue?vue&type=script&lang=js"

import "./CrmPointsCard.vue?vue&type=style&index=0&id=1f2c4ab4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f2c4ab4"]])

export default __exports__